import React from "react";
import { useSiteConfig } from "../context/SiteConfigContext";
import { Link } from "react-router-dom";

const Footer = () => {
  const { siteConfig } = useSiteConfig();
  return (
    <>
      <footer className="footer-mrv pt-5">
        <div className="container">
          <div className="row g-4 pb-5">
            <div className="col-lg-4 col-md-6">
              <a
                className="navbar-brand mrv-nav-logo d-flex align-items-center"
                href="#"
              >
                <div className="logo-circle-container">
                  <img
                    src={siteConfig?.logo}
                    alt="MRV Logo"
                    className="mrv-logo-img"
                    loading="lazy"
                  />
                </div>
                {/* <div class="mrv-brand-content ms-2">
            <span class="mrv-logo-text">MRV SCHOOL</span>
            <p class="mrv-location-text mb-0">Dwarka, New Delhi</p>
          </div> */}
              </a>
              <p className="text-white-50 pe-lg-5 mt-2">
                {siteConfig.description}
              </p>
              <div className="social-icons mt-4">
                {siteConfig?.socialMedia?.facebook && (
                  
                    <a
                      href={siteConfig.socialMedia.facebook}
                      target="_blank"
                      className="social-link"
                    >
                      <i className="bi bi-facebook"></i>
                    </a>
                )}
                {siteConfig?.socialMedia?.instagram && (
                    <a
                      href={siteConfig.socialMedia.instagram}
                      target="_blank"
                      className="social-link"
                    >
                     <i className="bi bi-instagram"></i>
                    </a>
                )}
                {siteConfig?.socialMedia?.twitter && (
                    <a
                      href={siteConfig.socialMedia.twitter}
                      target="_blank"
                      className="social-link"
                    >
                      <i className="bi bi-twitter"></i>
                    </a>
                )}
                {siteConfig?.socialMedia?.youtube && (
                    <a
                      href={siteConfig.socialMedia.youtube}
                      target="_blank"
                      className="social-link"
                    >
                      <i className="bi bi-youtube"></i>
                    </a>
                )}
              </div>
            </div>
            <div className="col-lg-2 col-6">
              <h5 className="text-white fw-bold mb-4 border-start border-maroon border-4 ps-3">
                Explore
              </h5>
              <ul className="list-unstyled footer-links">
                <li>
                  <Link to="/about-us">About Us</Link>
                </li>
                <li>
                  <Link to="/our-leader">Our Leaders</Link>
                </li>
                <li>
                  <Link to="/branches">Branches</Link>
                </li>
                <li>
                  <Link to="/contact-us">Contact Us</Link>
                </li>
              </ul>
            </div>
            <div className="col-lg-2 col-6">
              <h5 className="text-white fw-bold mb-4 border-start border-maroon border-4 ps-3">
                Resources
              </h5>
              <ul className="list-unstyled footer-links">
                <li>
                  <Link to="/achievements">Achievements</Link>
                </li>
                <li>
                  <Link to="/faculty">Faculty</Link>
                </li>
                <li>
                  <Link to="/news-and-events">News & Events</Link>
                </li>
                <li>
                  <Link to="/academics">Academics</Link>
                </li>
              </ul>
            </div>
            <div className="col-lg-4 col-md-6">
              <h5 className="text-white fw-bold mb-4 border-start border-maroon border-4 ps-3">
                Find Us
              </h5>
              <div className="contact-item d-flex mb-3">
                <i className="bi bi-geo-alt-fill text-white me-3" />
                <span className="text-white-50 small">
                  {siteConfig.address}
                </span>
              </div>
              <div className="contact-item d-flex mb-3">
                <i className="bi bi-telephone-fill text-white me-3" />
                <span className="text-white-50 small">{siteConfig.phone}, {siteConfig.landline1}, {siteConfig.landline2}</span>
              </div>
              <div className="contact-item d-flex mb-3">
                <i className="bi bi-envelope-fill text-white me-3" />{" "}
                <a href={`mailto:${siteConfig.email}`}className="text-white-50 small text-decoration-none">{siteConfig.email}</a>
              </div>
              <div
                className="mini-map mt-3 rounded-0 overflow-hidden shadow-sm"
                style={{ height: 120 }}
              >
                <iframe
                  src={siteConfig?.mapEmbed}
                  width="100%"
                  height="100%"
                  style={{ border: 0 }}
                  allowFullScreen
                  loading="lazy"
                />
              </div>
            </div>
          </div>
          <div className="footer-bottom py-3 border-top border-secondary">
            <div className="row align-items-center">
              <div className="col-md-6 text-center text-md-start">
                <p className="mb-0 text-white-50 small">
                  © 2026 MRV School. All Rights Reserved.
                </p>
              </div>
              <div className="col-md-6 text-center text-md-end">
                <p className="mb-0 text-white-50 small">
                  Designed &amp; Developed with Axepert Exhibits
                </p>
              </div>
            </div>
          </div>
        </div>
      </footer>
    </>
  );
};

export default Footer;
